import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import axiosInstance from "../../axios";
import {toast} from 'react-toastify'
import District from '../Dropdowns/District'
import State from '../Dropdowns/States'
import Photos from '../MultipleUpload'
export default function UpdateProduct({
    updatePlacementData,
    updateModalSetting,
    handlePageUpdate
}) {
  const {
    student_id,
    attendee_id,
    upsdm_id,
    fullname,
    is_placed,
    self_employed,
    placement_id,
    udyog_aadhar,
    company,
    position,
    employer_name,
    emp_email,
    salary_slip,
    emp_contact_no,
    salary_amount,
    bank_statement,
    offer_letter,
    date_of_joining,
    company_address,
    name_of_business,
    business_place_address,
    business_pin_code,
    business_start_date,
    benificiary_mobile,
    business_state,
    business_district,
    business_city,
    turnover_till_date,
    bank_details,
    upload_business_photo, 
    upload_gumasta,
    trade_license,
    proof_enterprise_setup,
    authentication_proof,
    loan_availed,
    another_documentary_proof,
    additional_earning,
    first_salary_amount,
    second_salary_amount,
    third_salary_amount,
    fourth_salary_amount,
    fifth_salary_amount,
    sixth_salary_amount,
    first_salary_slip,
    second_salary_slip,
    third_salary_slip,
    fourth_salary_slip,
    fifth_salary_slip,

} = updatePlacementData;
const formatDate= (dateStr) => {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
const [salary, setSalary] = useState(salary_slip || '');
const [firstSalary,setFirstSalary]=useState(first_salary_amount||'')
const [secondSalary,setSecondSalary]=useState(second_salary_amount||'')
const [thirdSalary,setThirdSalary]=useState(third_salary_amount||'')
const [fourthSalary,setFourthSalary]=useState(fourth_salary_amount||'')
const [fifthSalary,setFifthSalary]=useState(fifth_salary_amount||'')
const [sixthSalary,setSixthSalary]=useState(sixth_salary_amount||'')
const [open, setOpen] = useState(true);
const cancelButtonRef = useRef(null);
const [isPlaced, setIsPlaced] = useState(is_placed || "Not Placed");
const [self, setSelf] = useState(self_employed ||'');
const [bank, setBank] = useState(bank_statement || '');
const[state,setState]=useState(business_state||'')
const [district,setDistrict]=useState(business_district||'')
const[photo,setPhotos]=useState(upload_business_photo||[])
const[gumasta,setGumasta]=useState(upload_gumasta||'')
const[trade,setTrade]=useState(trade_license||'')
const[proof,setProof]=useState(proof_enterprise_setup||'')
const[auth,setAuth]=useState(authentication_proof||'')
const[bankS,setBankS]=useState(additional_earning||'')
const[document,setDocument]=useState(another_documentary_proof||'')
const [offer, setOffer] = useState(offer_letter || '');
const [placement, setPlacement] = useState({
    placement_id: placement_id || '',
    company: company || '',
    position: position || '',
    emp_contact: emp_contact_no || '',
    emp_name: employer_name || '',
    emp_email: emp_email || '',
    udyog_aadhar: udyog_aadhar || '',
    salary_amount: salary_amount || '',
    date_of_joining:formatDate(date_of_joining)||'',
    company_address:company_address||'',
    name_of_business:name_of_business||'',
    business_place_address:business_place_address||'',
    business_pin_code:business_pin_code||"",
    business_start_date:formatDate(business_start_date)||"",
    loan_availed:loan_availed||"",
    bank_details:bank_details||'',
    turnover_till_date:turnover_till_date||'',
    benificiary_mobile:benificiary_mobile||'',
    business_city:business_city||'',
    first_salary_amount:first_salary_amount||'',
    second_salary_amount:second_salary_amount||'',
    third_salary_amount:third_salary_amount||'',
    fourth_salary_amount:fourth_salary_amount||'',
    fifth_salary_amount:fifth_salary_amount||'',
    sixth_salary_amount:sixth_salary_amount||'',

});
const resetLeased=()=>{
  setPlacement({
    company: null,
    position: null,
    emp_contact: null,
    emp_name: null,
    emp_email: null,
    salary_amount: null,
    date_of_joining: null,
    company_address: null,
  })
  setBank(null)
  setSalary(null)
  setOffer(null)
}
const resetSelfEmployed=()=>{
  setPlacement({
    name_of_business:null,
    business_pin_code:null,
    business_state:null,
    business_district:null,
    business_city:null,
    business_place_address:null,
    business_start_date:null,
    loan_availed:null,
    turnover_till_date:null
  })
  setBankS(null)
  setProof(null)
  setGumasta(null)
  setTrade(null)
  setAuth(null)
  setDocument(null)
  setPhotos([])
  setState(null)
  setDistrict(null)
}
const resetForm=()=>{
  setPlacement({
    name_of_business:null,
    business_pin_code:null,
    business_city:null,
    business_place_address:null,
    business_start_date:null,
    loan_availed:null,
    turnover_till_date:null,
    company: null,
    position: null,
    emp_contact: null,
    emp_name: null,
    emp_email: null,
    salary_amount: null,
    date_of_joining: null,
    company_address: null
  })
  setBankS(null)
  setState(null)
  setDistrict(null)
  setProof(null)
  setGumasta(null)
  setTrade(null)
  setAuth(null)
  setDocument(null)
  setPhotos(null)
  setBank(null)
  setSalary(null)
  setOffer(null)
}
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPlacement(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleImagesChange = (newPhotos) => {
    setPhotos(newPhotos);
  };
  const handleOfferChange=(e)=>{
    setOffer(e.target.files[0])
  }

const addPlacement = () => {
  if (isPlaced === 'Placed' && self === '') {
    toast.error('Please Enter Placement Type');
    return;
  }
  if(isPlaced==='Not Placed'){
    resetForm()
  }
    const formData = new FormData();
    formData.append('is_placed', isPlaced||'Not Placed');
    if (isPlaced === 'Not Placed') {
  formData.append('self_employed', null);
} else {
  formData.append('self_employed', self || null);
}
    if(self==='No'){
      resetSelfEmployed()
      formData.append('company', placement.company);
      formData.append('position', placement.position);
      formData.append('emp_contact_no', placement.emp_contact);
      formData.append('employer_name', placement.emp_name);
      formData.append('emp_email', placement.emp_email);
      formData.append('salary_slip', salary);
      formData.append('bank_statement',bank);
    formData.append('offer_letter',offer);
    formData.append('salary_amount',placement.salary_amount)
    formData.append('date_of_joining',placement.date_of_joining)
    formData.append('company_address',placement.company_address)
    formData.append('first_salary_amount',placement.first_salary_amount) 
    formData.append('first_salary_slip',firstSalary)
    formData.append('second_salary_amount',placement.second_salary_amount)
    formData.append('second_salary_slip',secondSalary)
    formData.append('third_salary_amount',placement.third_salary_amount)
    formData.append('third_salary_slip',thirdSalary)
    formData.append('fourth_salary_amount',placement.fourth_salary_amount)
    formData.append('fourth_salary_slip',fourthSalary)
    formData.append('fifth_salary_amount',placement.fifth_salary_amount)
    formData.append('fifth_salary_slip',fifthSalary)
    formData.append('sixth_salary_amount',placement.sixth_salary_amount)
    formData.append('sixth_salary_slip',sixthSalary)
    ///////
    }
else{
  resetLeased()
  formData.append('name_of_business',placement.name_of_business)
  formData.append('business_pin_code',placement.business_pin_code)
  formData.append('business_state',state)
  formData.append('business_district',district)
  formData.append('business_city',placement.business_city)
  formData.append('business_place_address',placement.business_place_address)
  formData.append('business_start_date',placement.business_start_date)
  formData.append('bank_details',placement.bank_details)
  formData.append('additional_earning',bankS)
  formData.append('benificiary_mobile',placement.benificiary_mobile)
  formData.append('turnover_till_date',placement.turnover_till_date)
  formData.append('loan_availed',placement.loan_availed)
  formData.append('proof_enterprise_setup',proof)
  formData.append('upload_gumasta',gumasta)
  formData.append('trade_license',trade)
  formData.append('authentication_proof',auth)
  formData.append('another_documentary_proof',document)
  for(let i=0;i<photo.length;i++){
    formData.append('upload_business_photo', photo[i])
  }
}
    
    axiosInstance.put(`students/updateplacement/${student_id}`, formData)
      .then((response) => {
        handlePageUpdate();
        updateModalSetting();
        toast.success('Placement Details Updated');
      })
      .catch((error) => {
        console.log(error);
        toast.error('Failed to update Placement Details');
      });
};

  const dont=true
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left 
              shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 mb-4 text-gray-900 "
                      >
                        Add Placement Details
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                        <div>
                            <label 
                              htmlFor="attendee_id"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                            SIP ID
                            </label>
                            <p
                             className=" text-gray-900 text-sm  block w-full p-2.5 dark:bg-gray-700">
                                {attendee_id}
                             </p>
                          </div>
                          <div>
                            <label 
                              htmlFor="upsdm_id"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                          Candidate ID
                            </label>
                            <p
                             className="  text-gray-900 text-sm  block w-full p-2.5 dark:bg-gray-700">
                                {upsdm_id}
                             </p>
                          </div>
                          <div>
                 <label 
                 htmlFor="fullname"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Student Name
 </label>
 <p
                             className="  text-gray-900 text-sm  block w-full p-2.5 dark:bg-gray-700">
                                {fullname}
                             </p>
                   </div>
                          <div>
                            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" 
                            htmlFor="isPlaced">
        Placement Status
      </label>
        <select
          id="isPlaced"
          onChange={(e)=>setIsPlaced(e.target.value)}
          value={isPlaced}
                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value='' disabled>Select Status</option>
          <option value="Placed">Placed</option>
          <option value="Not Placed">Not Placed</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        </div>
        </div> 
        
                
                     
      {(isPlaced==='Placed') &&(<>
                   <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" 
        htmlFor="self">
Placement Type
</label>
<select
id="self"
onChange={(e)=>setSelf(e.target.value)}
value={self}
className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
>
<option value='' disabled>Select Status</option>
<option value="Yes">Self Employed</option>
<option value="No">Leased Employed</option>
</select>
<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
</div>  

        </div>
       
      </>
       
      )}
      {
        (self==='Yes'&&isPlaced==='Placed') &&(
          <>
            <div>
            <label 
            htmlFor="name_of_business"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
  Name of Business
</label>
<input
type="text"
id="name_of_business"
name="name_of_business"
value={placement.name_of_business}
onChange={handleInputChange}
className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
              </div>
              <div>
                 <label 
                 htmlFor="business_place_address"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Business Address
 </label>
 <input
   type="text"
   id="business_place_address"
   name="business_place_address"
   value={placement.business_place_address}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                 <label 
                 htmlFor="benificiary_mobile"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Beneficiary Mobile
 </label>
 <input
   type="tel"
   id="benificiary_mobile"
   name="benificiary_mobile"
   value={placement.benificiary_mobile}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                 <label 
                 htmlFor="business_pin_code"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Business Pincode
 </label>
 <input
   type="text"
   id="business_pin_code"
   name="business_pin_code"
   value={placement.business_pin_code}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div><div>
                            <State handleChange={e=>setState(e.target.value)} value={state} />
                            </div>
                            <div>
                              <District selectedState={state} 
                              handleChange={e=>setDistrict(e.target.value)} 
                              value={district} />
                            </div>
                   <div>
                 <label 
                 htmlFor="business_city"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Business City
 </label>
 <input
   type="text"
   id="business_city"
   name="business_city"
   value={placement.business_city}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                        <div>
                 <label 
                 htmlFor="business_start_date"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Business Start Date
 </label>
 <input
   type="date"
   id="business_start_date"
   name="business_start_date"
   value={placement.business_start_date}
   
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                 <label 
                 htmlFor="bank_details"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Bank Details
 </label>
 <input
   type="text"
   id="bank_details"
   name="bank_details"
   value={placement.bank_details}
   
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>            
                   <div>
                 <label 
                 htmlFor="turnover_till_date"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Turnover Till Date
 </label>
 <input
   type="text"
   id="turnover_till_date"
   name="turnover_till_date"
   value={placement.turnover_till_date}
   
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>   
                   <div>
                 <label 
                 htmlFor="loan_availed"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Loan Availed
 </label>
 <input
   type="text"
   id="loan_availed"
   name="loan_availed"
   value={placement.loan_availed}
   
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/> 
                   </div>   
                   <h1 className="text-2xl">Documents</h1>
                   <div className="w-full h-px col-span-4 bg-gray-800 my-2"></div>
                   <p className="text-red-600 col-span-4 text-center">*Please Upload Only PDF/JPEG/JPG/PNG Files</p>
<div>
<label 
            htmlFor="name_of_business"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
  Business Photos
</label>
  <Photos onImagesChange={handleImagesChange}/>
  </div>
                   <div>
                            <label htmlFor="gumasta"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Gumasta Certificate</label>
                            <label
        htmlFor="gumasta"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {gumasta?.name && gumasta.name.length > 8
            ? gumasta.name.substring(0, 8) + "..."
            : gumasta?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="gumasta"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setGumasta(e.target.files[0])}
      />
                          </div>
                          <div>
                            <label htmlFor="trade"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Trade License</label>
                            <label
        htmlFor="trade"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {trade?.name && trade.name.length > 8
            ? trade.name.substring(0, 8) + "..."
            : trade?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="trade"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setTrade(e.target.files[0])}
      />
                          </div>
                          <div>
                            <label htmlFor="proof"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Proof-Enterprise Setup</label>
                            <label
        htmlFor="proof"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {proof?.name && proof.name.length > 8
            ? proof.name.substring(0, 8) + "..."
            : proof?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="proof"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setProof(e.target.files[0])}
      />
                          </div>  
                          <div>
                            <label htmlFor="auth"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Authentication Proof</label>
                            <label
        htmlFor="auth"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {auth?.name && auth.name.length > 8
            ? auth.name.substring(0, 8) + "..."
            : auth?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="auth"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setAuth(e.target.files[0])}
      />
                          </div> 
                          <div>
                            <label htmlFor="bankS"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Statement</label>
                            <label
        htmlFor="bankS"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {bankS?.name && bankS.name.length > 8
            ? bankS.name.substring(0, 8) + "..."
            : bankS?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="bankS"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setBankS(e.target.files[0])}
      />
                          </div>   
                          <div>
                            <label htmlFor="document"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Documentary Proof</label>
                            <label
        htmlFor="document"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {document?.name && document.name.length > 8
            ? document.name.substring(0, 8) + "..."
            : document?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="document"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setDocument(e.target.files[0])}
      />
                          </div>                                   
</>
        )
      }
      {(self==='No' && isPlaced==='Placed')&&(
        <>
         <div>
                 <label 
                 htmlFor="date_of_joining"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Date of Joining
 </label>
 <input
   type="date"
   id="date_of_joining"
   name="date_of_joining"
   value={placement.date_of_joining}
   
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
         <div>
                 <label 
                 htmlFor="emp_name"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Employer Name
 </label>
 <input
   type="text"
   id="emp_name"
   name="emp_name"
   value={placement.emp_name}
   
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>

                   <div>
                 <label 
                 htmlFor="emp_contact"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Employer Contact no.
 </label>
 <input
   type="text"
   id="emp_contact"
   name="emp_contact"
   value={placement.emp_contact}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                 <label 
                 htmlFor="emp_email"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Employer Email
 </label>
 <input
   type="text"
   id="emp_email"
   name="emp_email"
   value={placement.emp_email}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
        
             <div>
                 <label 
                 htmlFor="company"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Company Name
 </label>
 <input
   type="text"
   id="company"
   name="company"
   value={placement.company}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                 <label 
                 htmlFor="company_address"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Company Address
 </label>
 <input
   type="text"
   id="company_address"
   name="company_address"
   value={placement.company_address}
   
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                 <label 
                 htmlFor="position"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Position
 </label>
 <input
   type="text"
   id="position"
   name="position"
   value={placement.position}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                  
             <div>
                            <label htmlFor="bank"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Statement</label>
                            <label
        htmlFor="bank"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {bank?.name && bank.name.length > 8
            ? bank.name.substring(0, 8) + "..."
            : bank?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="bank"
        className="hidden"
        accept="images/pdf"
        onChange={(e)=>setBank(e.target.files[0])}
      />
                          </div>
                          <div>
                            <label htmlFor="offer"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Offer Letter</label>
                            <label
        htmlFor="offer"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {offer?.name && offer.name.length > 8
            ? offer.name.substring(0, 8) + "..."
            : offer?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="offer"
        className="hidden"
        accept="images/pdf"
        onChange={handleOfferChange}
      />
                          </div>
        </>
      )}
      {(self!==''&& isPlaced ==='Placed')&&(
        <>
        <hr/>
          <h1 className="text-2xl col-span-4">Income / Salary Details</h1>
          <div className="w-full h-px col-span-4 bg-gray-800 my-2"></div>
        <div>
                 <label 
                 htmlFor="salary_amount"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       Basic CTC
 </label>
 <input
   type="text"
   id="salary_amount"
   name="salary_amount"
   value={placement.salary_amount}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                            <label htmlFor="salary"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Salary Slip</label>
                            <label
        htmlFor="salary"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {salary?.name && salary.name.length > 8
            ? salary.name.substring(0, 8) + "..."
            : salary?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="salary"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setSalary(e.target.files[0])}
      />
                          </div>

<div>
                 <label 
                 htmlFor="first_salary_amount"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       1st Month Salary Amount
 </label>
 <input
   type="text"
   id="first_salary_amount"
   name="first_salary_amount"
   value={placement.first_salary_amount}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                            <label htmlFor="first_salary_slip"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >1st Month Salary Slip</label>
                            <label
        htmlFor="first_salary_slip"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {firstSalary?.name && firstSalary.name.length > 8
            ? firstSalary.name.substring(0, 8) + "..."
            : firstSalary?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="first_salary_slip"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setFirstSalary(e.target.files[0])}
      />
                          </div>

                          <div>
                 <label 
                 htmlFor="second_salary_amount"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       2nd Month Salary Amount
 </label>
 <input
   type="text"
   id="second_salary_amount"
   name="second_salary_amount"
   value={placement.second_salary_amount}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                            <label htmlFor="second_salary_slip"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >2nd Month Salary Slip</label>
                            <label
        htmlFor="second_salary_slip"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {secondSalary?.name && secondSalary.name.length > 8
            ? secondSalary.name.substring(0, 8) + "..."
            : secondSalary?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="second_salary_slip"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setSecondSalary(e.target.files[0])}
      />
                          </div>

                          <div>
                 <label 
                 htmlFor="third_salary_amount"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       3rd Month Salary Amount
 </label>
 <input
   type="text"
   id="third_salary_amount"
   name="third_salary_amount"
   value={placement.third_salary_amount}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                            <label htmlFor="third_salary_slip"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >3rd Month Salary Slip</label>
                            <label
        htmlFor="third_salary_slip"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {thirdSalary?.name && thirdSalary.name.length > 8
            ? thirdSalary.name.substring(0, 8) + "..."
            : thirdSalary?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="third_salary_slip"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setThirdSalary(e.target.files[0])}
      />
                          </div>

                          <div>
                 <label 
                 htmlFor="fourth_salary_amount"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       4th Month Salary Amount
 </label>
 <input
   type="text"
   id="fourth_salary_amount"
   name="fourth_salary_amount"
   value={placement.fourth_salary_amount}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                            <label htmlFor="fourth_salary_slip"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >4th Month Salary Slip</label>
                            <label
        htmlFor="fourth_salary_slip"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {fourthSalary?.name && fourthSalary.name.length > 8
            ? fourthSalary.name.substring(0, 8) + "..."
            : fourthSalary?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="fourth_salary_slip"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setFourthSalary(e.target.files[0])}
      />
                          </div>

                          <div>
                 <label 
                 htmlFor="fifth_salary_amount"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       5th Month Salary Amount
 </label>
 <input
   type="text"
   id="fifth_salary_amount"
   name="fifth_salary_amount"
   value={placement.fifth_salary_amount}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                            <label htmlFor="fifth_salary_slip"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >5th Month Salary Slip</label>
                            <label
        htmlFor="fifth_salary_slip"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {fifthSalary?.name && fifthSalary.name.length > 8
            ? fifthSalary.name.substring(0, 8) + "..."
            : fifthSalary?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="fifth_salary_slip"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setFifthSalary(e.target.files[0])}
      />
                          </div>

                          <div>
                 <label 
                 htmlFor="sixth_salary_amount"
                 className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
       6th Month Salary Amount
 </label>
 <input
   type="text"
   id="sixth_salary_amount"
   name="sixth_salary_amount"
   value={placement.sixth_salary_amount}
   onChange={handleInputChange}
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                   </div>
                   <div>
                            <label htmlFor="sixth_salary_slip"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >6th Month Salary Slip</label>
                            <label
        htmlFor="sixth_salary_slip"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {sixthSalary?.name && sixthSalary.name.length > 8
            ? sixthSalary.name.substring(0, 8) + "..."
            : sixthSalary?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="sixth_salary_slip"
        className="hidden"
        accept="images/pdf"
        onChange={e=>setSixthSalary(e.target.files[0])}
      />
                          </div>
        </>

      )}
                    
                 </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={addPlacement}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() =>  updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
